(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shotcrimp-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-media-gallery')) {
    customElements.define('sc-media-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const viewer = this.querySelector('.sc-gallery__viewer');
        const more = this.querySelector('.sc-gallery__more');
        let opener;
        const pending = () => [...this.querySelectorAll('template[data-gallery-deferred]')];
        more.hidden = pending().length === 0;
        more.addEventListener('click', () => {
          const batch = pending().slice(0, 12);
          batch.forEach(template => template.replaceWith(template.content));
          more.hidden = pending().length === 0;
          batch.length && this.querySelectorAll('.sc-gallery__item:not(:has(> template))')[this.querySelectorAll('.sc-gallery__item:not(:has(> template))').length - batch.length]?.querySelector('a')?.focus({ preventScroll: true });
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('.sc-gallery__open');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          opener = link;
          viewer.replaceChildren();
          if (link.hasAttribute('data-gallery-video')) {
            viewer.append(link.parentElement.querySelector('template[data-gallery-player]').content.cloneNode(true));
          } else {
            const image = document.createElement('img');
            image.src = link.href;
            image.alt = link.querySelector('img').alt;
            viewer.append(image);
          }
          dialog.showModal();
          const video = viewer.querySelector('video');
          if (video) video.play().catch(() => {});
        });
        this.querySelector('.sc-gallery__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const bounds = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => {
          viewer.querySelector('video')?.pause();
          viewer.replaceChildren();
          opener?.focus({ preventScroll: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
